module.exports = __webpack_public_path__ + "img/logo-pruvo-white.4c3c8a41.png";